import React, { useState } from "react";
import PreBooking from "./PreBooking";
import PreBookingRecord from "./PreBookingRecord";

const PreRegistrationPage = () => {
  const [mode, setMode] = useState("grid");
  const [currentEditData, setCurrentEditData] = useState("");

  return (
    <>
      {mode === "grid" ? (
        <PreBookingRecord setMode={setMode} setCurrentEditData={setCurrentEditData} />
      ) : (
        <PreBooking setMode={setMode} mode={mode} currentEditData={currentEditData} />
      )}
    </>
  );
};

export default PreRegistrationPage;
